import React from 'react'
import {makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tile from 'components/Tile';
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import ForumIcon from '@material-ui/icons/Forum'
import GroupIcon from '@material-ui/icons/Group'
import DescriptionIcon from '@material-ui/icons/Description'
import MailIcon from '@material-ui/icons/Mail';
import Tr from 'translations/Translations';
import scrollTo from "libs/scrollTo";
import RouterPath from "libs/RouterPath";
import {withRouter} from "react-router";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        '&>*:not(:first-child)': {
            marginLeft: theme.spacing(2),
        },
        marginBottom: theme.spacing(4)
    },
    icon: {
        fontSize: theme.components.icon.fontSize,
    },
    mirror: {
        transform: 'scaleX(-1)'
    },
    tile: {
        width: 225,
        height: 203,
    }
}));

function TilesRow(
    {
        match,
        offerCollectionOrModification,
        demandStatistics
    }) {
    const classes = useStyles();
    const demandId = match.params.id;

    const handleCorrespondenceClick = () => {
        if (!demandStatistics.operatorQnALink) {
            const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_CORRESPONDENCE_ID, {id: demandId});
            RouterPath.redirect(href)
        } else {
            window.location.href = demandStatistics.operatorQnALink.url;
        }
    };

    const handleDocumentsClick = (e) => {
        e.preventDefault();
        if (offerCollectionOrModification) {
            scrollTo("#documentsSection")
        } else {
            const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_3_ID, {id: demandId});
            RouterPath.redirect(href)
        }
    }

    const handleOffersClick = (e) => {
        e.preventDefault();
        if (offerCollectionOrModification) {
            scrollTo("#offersSection")
        } else {
            const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_3_ID, {id: demandId});
            RouterPath.redirect(href)
        }
    }


    return (
        <>
            <div className={classes.root}>
                <Tile
                    className={classes.tile}
                    icon={<ForumIcon className={classes.icon}/>}
                    text={Tr('messages')}
                    numberText={demandStatistics.numberOfUnreadMessagesFromSuppliers + ' / ' + demandStatistics.numberOfMessagesFromSuppliers}
                    onClick={(e) => {
                        e.preventDefault();
                        handleCorrespondenceClick();
                    }}
                />
                <Tile
                    className={classes.tile}
                    icon={<LocalOfferIcon className={classes.icon}/>}
                    text={Tr('offers')}
                    numberText={demandStatistics.numberOfOffers.toString()}
                    onClick={handleOffersClick}
                />
                <Tile
                    className={classes.tile}
                    icon={<GroupIcon className={classes.icon}/>}
                    text={Tr('contractors')}
                    numberText={demandStatistics.numberOfSuppliers.toString()}
                    onClick={(e) => {
                        e.preventDefault();
                        scrollTo("#contractorSection")
                    }}
                />
                <Tile
                    className={classes.tile}
                    icon={<DescriptionIcon className={classes.icon}/>}
                    text={Tr('documents')}
                    numberText={demandStatistics.numberOfAttachments.toString()}
                    onClick={handleDocumentsClick}
                />
                <Tile
                    className={classes.tile}
                    icon={<MailIcon className={classes.icon}/>}
                    text={Tr('email_list')}
                    numberText={demandStatistics.numberOfEmails.toString()}
                    onClick={(e) => {
                        e.preventDefault();
                        const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_EMAIL_LIST_ID, {id: demandId});
                        RouterPath.redirect(href)
                    }}
                />
            </div>
        </>
    )
}

TilesRow.propTypes = {
    offerCollectionOrModification: PropTypes.bool.isRequired,
    demandStatistics: PropTypes.object.isRequired,
}

TilesRow.defaultProps = {}


export default withRouter(TilesRow);